import { graphqlRequest } from './graphqlRequest';

const GET_SERVICE_CATALOG = `
  query GetServiceCatalog {
    getService(includeStats: false) {
      id
      service
      description
      serviceId
    }
  }
`;

let cached = null;
let cachedAt = 0;
let inflight = null;
const TTL_MS = 60_000;

export async function fetchServiceCatalog() {
  if (cached && Date.now() - cachedAt < TTL_MS) return cached;
  if (inflight) return inflight;
  inflight = graphqlRequest(GET_SERVICE_CATALOG)
    .then((data) => {
      cached = Array.isArray(data?.getService) ? data.getService : [];
      cachedAt = Date.now();
      return cached;
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

export function invalidateServiceCatalog() {
  cached = null;
  cachedAt = 0;
}
